// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___2FTbN","overlayModal":"style__overlayModal___6PzNb","overlayModalInner":"style__overlayModalInner___kJTpp","overlayCloseButton":"style__overlayCloseButton___3ElSA","overlayModalTitle":"style__overlayModalTitle___1bvPS","overlayModalText":"style__overlayModalText___8UNFr","overlayModalTextBold":"style__overlayModalTextBold___28fGR","overlayModalButtons":"style__overlayModalButtons___1Z1Xc","overlayModalButtonsItem":"style__overlayModalButtonsItem___uxmOX","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___3OcdT","buttonActive":"style__buttonActive___2XoIy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-login/style.css
// module id = 525
// module chunks = 0